<template>
  <!-- 页面内图标 sprite：eb- 前缀避免与全局/其他页面 sprite 的 symbol id 冲突 -->
  <svg width="0" height="0" style="position: absolute" aria-hidden="true">
    <symbol id="eb-upload" viewBox="0 0 24 24"><path d="M12 16V4M7 9l5-5 5 5" /><path d="M5 13v7h14v-7" /></symbol>
    <symbol id="eb-download" viewBox="0 0 24 24"><path d="M12 4v11M7 10l5 5 5-5" /><path d="M5 20h14" /></symbol>
    <symbol id="eb-send" viewBox="0 0 24 24"><path d="m3 11 18-8-8 18-2-8z" /><path d="m11 13 10-10" /></symbol>
    <symbol id="eb-x" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></symbol>
    <symbol id="eb-file" viewBox="0 0 24 24"><path d="M6 3h8l4 4v14H6z" /><path d="M14 3v5h5" /><path d="M9 13h6M9 17h4" /></symbol>
    <symbol id="eb-chevron" viewBox="0 0 24 24"><path d="m9 10 3 3 3-3" /></symbol>
    <symbol id="eb-left" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6" /></symbol>
    <symbol id="eb-edit" viewBox="0 0 24 24"><path d="M4 20h4l11-11-4-4L4 16v4z" /><path d="m13 7 4 4" /></symbol>
  </svg>
</template>
